module.exports = __webpack_public_path__ + "static/media/Image 22@2x.2accb456.png";